import { SearchCityDatesAdultsModeEnum } from './search-city-dates-adults.enum'

export const getSearchCityDatesAdultClassNameByEnum = (
  searchCityDatesAdultsModeEnum: SearchCityDatesAdultsModeEnum,
): string => {
  switch (searchCityDatesAdultsModeEnum) {
    case SearchCityDatesAdultsModeEnum.HOUSE_SEARCH:
      return 'houseSearch'
    default:
      return 'default'
  }
}
